import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewAsComponent } from './view-as.component';


const routes: Routes = [
  {
    path: '',
    component: ViewAsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewAsRoutingModule { }
